import * as React from 'react';
import Style from './assets/style.scss';
import { IFileExplorerItemClickEventArgs, IFileExplorerItemProps } from './entities';
import { GetIconComponent } from '@bimser/icons';

import classNames from 'classnames/bind';
const cx = classNames.bind(Style);

const itemStlyes: React.CSSProperties = { marginLeft: 'auto', marginRight: 'auto' };

const BCFileExplorerItem = (props: IFileExplorerItemProps) => {
	const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		const clickEventArgs: IFileExplorerItemClickEventArgs = {
			senderArgs: e,
			data: props
		};

		props.onClick(clickEventArgs);
		e.stopPropagation();
	};

	const onDoubleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
		const clickEventArgs: IFileExplorerItemClickEventArgs = {
			senderArgs: e,
			data: props
		};

		props.onDoubleClick(clickEventArgs);
		e.stopPropagation();
	};

	const classNames = cx({
		fileExplorerItem: true,
		selected: props.selected
	});
	const Icon = GetIconComponent(props.icon, {
		width: '38px',
		height: '50px',
		style: itemStlyes
	});

	return (
		<div
			className={classNames}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
		>
			<div className={Style.fileIcon}>{Icon}</div>
			<span
				className={Style.fileName}
				title={props.text}
			>
				{props.text}
			</span>
		</div>
	);
};
export default BCFileExplorerItem;
